import icLogoMengxiangyun from '@/assets/imgs/logo-mengxiangyun.png';
import icLogoAjimide from '@/assets/imgs/logo-ajimide.png';

const apiOrigin = process.env.VUE_APP_API_ORIGIN;
const apiUploadOrigin = process.env.VUE_APP_UPLOAD;

export const avatarDefault =
    'https://filetest-oss.aikucun.com/akucun-saas-merchant/9e6a55b6b4563e652a23be9d623ca5055c356940_1627872758142_35.png';

// 左上角显示的信息
const titleInfo = {
    4: {
        title: '啊团',
        logo: icLogoAjimide
    },
    3: {
        title: '阿基米德',
        logo: icLogoAjimide
    },
    2: {
        title: '梦饷云',
        logo: icLogoMengxiangyun
    },
    6: {
        title: '供应链开放-经销',
        logo: icLogoMengxiangyun
    },
    7: {
        title: '供应链开放-代销',
        logo: icLogoMengxiangyun
    }
};

export { apiOrigin, titleInfo, apiUploadOrigin };
